import { render, staticRenderFns } from "./tagModel.vue?vue&type=template&id=4e52583f&scoped=true"
import script from "./tagModel.vue?vue&type=script&lang=js"
export * from "./tagModel.vue?vue&type=script&lang=js"
import style0 from "./tagModel.vue?vue&type=style&index=0&id=4e52583f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e52583f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e52583f')) {
      api.createRecord('4e52583f', component.options)
    } else {
      api.reload('4e52583f', component.options)
    }
    module.hot.accept("./tagModel.vue?vue&type=template&id=4e52583f&scoped=true", function () {
      api.rerender('4e52583f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tagModel.vue"
export default component.exports